import React, { useMemo, useState } from "react"
import { Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { useDispatch } from "react-redux"
import ActionButton from "../../common/button/actionbutton.component"
import SingleSelectListing from "../../common/listing/SingleSelectListing"
import { ReorderProductModalProps } from "../../common/types/inventory"
import { StockDocumentAction } from "../../state/inventory/stockdocument/actions"
import { RowQuickCreatePayload } from "../../state/pricing/services"
import { REORDER_MODAL_MESSAGES } from "../../utils/inventory"
import { getReorderProductsModalHeaders } from "../../utils/listing/utils"

export const ReorderProductsModal = injectIntl((props: ReorderProductModalProps) => {
    const [supplierId, setSupplierId] = useState(props.supplierId ?? "")
    const [loading, setLoading] = React.useState<boolean>(false)
    const locationName = props.reorderDetails?.locationName ?? ""

    const dispatch = useDispatch()


    const selectSupplier = (id: string) => {
        setSupplierId(id)
    }

    const groupedProducts = useMemo(() => {
        const groups = {}
        props.reorderDetails?.productsForReorder.forEach((product) => {
            const groupId = product.supplierId
            if (!groups[groupId]) {
                groups[groupId] = []
            }
            groups[groupId].push(product)
        })
        return groups
    }, [props.reorderDetails?.productsForReorder])
  
    const supplierIds = Object.keys(groupedProducts)
  
    const rows = useMemo(() => {
        const supplierRows = new Map()
        supplierIds.forEach((supplierId) => {
            const productsForCurrentSupplier = groupedProducts[supplierId]
            supplierRows.set(supplierId, [
                productsForCurrentSupplier[0]?.supplierName,
                productsForCurrentSupplier.length.toString(),
            ])
        })
        return supplierRows
    }, [groupedProducts])
  
    const onClick = async () => {
        setLoading(true)
        const rows: RowQuickCreatePayload[] = await Promise.all(
            groupedProducts[supplierId]?.map((product) => ({
                productId: product.productId,
                measure: product.reorderQuantity,
                cost: product.supplierCost,
            }))
        )
        const payload = { contactId: supplierId, locationId: props.reorderDetails?.locationId, rows: rows }
        dispatch(StockDocumentAction.quickCreate(payload))
    }
  
    const onClose = () => {
        if (!loading) {
            props.onCloseCallback()
        }
    }
  
    const isSupplierValid = supplierId !== ""

    return (
        <Modal
            className={"custom-modal"}
            show={true}
            onHide={onClose}
            scrollable={true}
            backdrop="static"
            centered={true}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.intl.formatMessage(REORDER_MODAL_MESSAGES["header"],{
                        location: locationName})}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{overflow: "visible"}}>
                <div className="p-3">
                    {props.intl.formatMessage(REORDER_MODAL_MESSAGES["selectText"])}
                </div>
                <div className="container-fluid">
                    <SingleSelectListing 
                        showHeaders={true} 
                        headers={getReorderProductsModalHeaders()} 
                        displayableContent={rows} 
                        onSelect={e => selectSupplier(e)}/>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <ActionButton
                    disabled={!isSupplierValid}
                    className="btn btn-primary"
                    onClick={onClick}
                >
                    {props.intl.formatMessage(REORDER_MODAL_MESSAGES["reorderButton"])}
                    
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )

})


// WEBPACK FOOTER //
// ./src/inventory/modals/ReorderProductsModal.tsx